import { z } from "zod";

import { PluginWidgetSchema_2023_08_20 } from "./2023-08-20";

export const PluginWidgetSchema_2024_05_05 = PluginWidgetSchema_2023_08_20;
export type PluginWidgetType_2024_05_05 = z.infer<
  typeof PluginWidgetSchema_2024_05_05
>;
